module.exports = __webpack_public_path__ + "img/workout9.ae80b446.jpg";